<template>
  <div class="main col">
    <div class="title">
      <img src="@/assets/2024/new_newbridge.png" style="width: 80px" alt="" />
      <div style="padding-top: 50px">
        <img src="@/assets/2024/new_title.png" style="width: 240px" alt="" />
      </div>
      <p style="padding-top: 40%">
        <img
          src="@/assets/2024/new_description.png"
          style="width: 170px"
          alt=""
        />
      </p>
      <div class="button-wrap">
        <p>테스트를 통해 나만의 달란트를 발견해 보세요!</p>
        <button class="test-btn" @click="onClickStartButton">
          테스트 시작하기
        </button>

        <div class="about">
          <a href="#" @click="openAbout">누가 이 페이지를 만들었나요?</a>
        </div>
      </div>
    </div>
    <div class="bg">
      <lottie :options="bgOptions" :loop="true" />
    </div>

    <AboutModal :modal="modal" :close="close" />
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import loop from "@/assets/json/loop.json";
// import bg from "@/assets/json/bg.json";
import bg from "@/assets/2024/json/bg_204.json";
import AboutModal from "@/components/AboutModal.vue";
export default {
  name: "HomeView",
  data() {
    return {
      modal: false,
    };
  },
  methods: {
    onClickStartButton() {
      this.$gtag.event("TestStart");
      this.$router.push("/test");
    },
    openAbout(e) {
      e.preventDefault();
      window.open("https://newbridgelab.imweb.me/about", "_blank");
      this.$gtag.event("About/Home");
      // this.modal = true;
    },
    close() {
      this.modal = false;
    },
  },
  components: {
    lottie: Lottie,
    AboutModal,
  },
  computed: {
    options() {
      return { animationData: loop };
    },
    bgOptions() {
      return { animationData: bg };
    },
  },
  created() {
    localStorage.removeItem("resultItem");
    this.$gtag.pageview({
      page_title: "메인 페이지",
      page_path: "/",
    });
  },
  mounted() {
    document
      .querySelector("g")
      .addEventListener("click", this.onClickStartButton);
  },
  destroyed() {
    document.removeEventListener("click", this.onClickStartButton);
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-top: 70px;
  position: relative;
  overflow-x: hidden;
  .test-btn {
    background: #000;
    color: #fff;
    height: 48px;
    border-radius: 7px;
    border: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
  }
  .button-wrap {
    margin-top: auto;
    padding: 50px 28px 50px;
  }
  p {
    padding-bottom: 20px;
    font-size: 14px;
    text-align: center;
  }
  .about {
    width: 100%;
    z-index: 20;
    padding-top: 40px;
    a {
      font-size: 12px;
      font-weight: 500;
      color: #adadad;
      text-decoration: underline;
    }
  }
  .visual {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.bg {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 110%;
  transform: translate(-50%, -50%);
  z-index: 10;
  &::v-deep {
    svg {
      /* filter: blur(10px); */
    }
  }
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }
}
.title {
  position: absolute;
  left: 50%;
  top: 0;
  width: 100%;
  transform: translate(-50%, 0);
  z-index: 20;
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
}
.button-wrap {
  margin-top: auto;
  width: 100%;

  button {
    width: 100%;
  }
}
</style>
